import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { type SankeyNode } from '@src/pages/journey-map/types';
import { EventRuleViewer } from '@src/pages/journey-map/components';

const StyledModal = styled(Modal)`
  .ant-modal-body {
    max-height: 70vh;
    overflow-y: auto;
  }
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 16px;
  color: #333;
`;

const EventList = styled.div`
  margin-top: 8px;
  font-family: monospace;
  font-size: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  scrollbar-width: thin;
  scrollbar-color: #999 #f8f9fa;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #666;
  }
`;

const EventItem = styled.div.attrs<{ html?: string }>(({ html }) => ({
  dangerouslySetInnerHTML: html ? { __html: html } : undefined,
}))<{ html?: string }>`
  font-size: 11px;
  color: #666;
  margin: 2px 0;
  padding: 8px;
  border-bottom: 1px dashed #ddd;
  background: white;
  border-radius: 4px;

  &:last-child {
    border-bottom: none;
  }
`;

interface NodeDetailModalProps {
  node: SankeyNode | null;
  visible: boolean;
  onClose: () => void;
}

const formatJSON = (obj: any) => {
  const replacer = (key: string, value: any) => {
    if (value === undefined) return 'undefined';
    if (value === null) return 'null';
    return value;
  };
  try {
    const formatted = JSON.stringify(obj, replacer, 2)
      .replace(/\n/g, '<br/>')
      .replace(/ /g, '&nbsp;')
      .replace(/[{]/g, '<span style="color: #666">{</span>')
      .replace(/[}]/g, '<span style="color: #666">}</span>')
      .replace(/[[\]]/g, (match) => `<span style="color: #666">${match}</span>`)
      .replace(/"([^"]+)":/g, '<span style="color: #2a5fb0">"$1"</span>:')
      .replace(/: "([^"]+)"/g, ': <span style="color: #1a8b1a">"$1"</span>')
      .replace(/: ([0-9.]+)/g, ': <span style="color: #1a8b1a">$1</span>');
    return formatted;
  } catch (e) {
    return String(obj);
  }
};

const NodeDetailModal: React.FC<NodeDetailModalProps> = ({ node, visible, onClose }) => {
  if (!node) return null;

  return (
    <StyledModal title="Node Details" open={visible} onCancel={onClose} footer={null} width={800}>
      <EventRuleViewer name={node.name} />
    </StyledModal>
  );
};

export default NodeDetailModal;
